import React, { useEffect, useRef, useState } from "react"
import { ButtonIcon } from "src/shared/components/forms/button-icon/ButtonIcon"
import InputDateModal from "src/shared/components/forms/input-date/sections/InputDateModal/InputDateModal"
import { useDate } from "src/shared/hooks/useDate"
import useGetCurrentDate from "src/shared/hooks/useGetCurrentDate"

interface DateFilterProps {
    onChange: (value: Date[]) => void
}

const DateFilter = ({ onChange }: DateFilterProps) => {
    const { areSameDay, setHHMMSS } = useDate()
    const { currentDate } = useGetCurrentDate()
    const [visible, setVisible] = useState<boolean>(false)
    const [value, setValue] = useState<Date[]>([])
    const appliedRangeKeyRef = useRef<string | null>(null)

    useEffect(() => {
        // En el montaje solo pintamos el valor visual. NO llamamos onChange porque
        // Reports ya inicializa dateFilter con el rango de hoy; hacerlo dispararía
        // un segundo fetch idéntico al inicial.
        appliedRangeKeyRef.current = null
        setValue([withFixedHour(currentDate)])
    }, [])

    const withFixedHour = (date: Date) =>
        setHHMMSS({
            startDate: date,
            newHour: "00:00:00.000",
            isNewHourInUTC: false,
        })

    const setInitialState = () => {
        appliedRangeKeyRef.current = null
        const baseDate = withFixedHour(currentDate)
        onChange([baseDate, baseDate])
        setValue([baseDate])
    }

    return (
        <>
            <InputDateModal
                isOpen={visible}
                height={"65dvh"}
                width={"494px"}
                onClose={() => {
                    setVisible(false)
                }}
                disabledAfterOrEqualDate={currentDate}
                onConfirm={() => {
                    if (!value?.length || value?.length < 1) {
                        return
                    }
                    if (value.length === 1) {
                        onChange([value[0], value[0]])
                        setVisible(false)
                        return
                    }
                    onChange(value)
                    setVisible(false)
                }}
                onReset={() => setInitialState()}
                isRange={true}
                onChange={(rawDate) => {
                    const date = withFixedHour(rawDate)
                    if (value.length === 0 || date <= value[0]) {
                        setValue([date])
                        return
                    }
                    if (value?.length === 2 && areSameDay(new Date(), date)) {
                        setValue([date])
                        return
                    }
                    if (value?.length === 2) {
                        setValue([])
                        return
                    }
                    setValue([value[0], date])
                }}
                value={value}
            />
            <ButtonIcon
                width="58px"
                type="button"
                theme={"secondary"}
                onClick={() => setVisible(true)}
                iconName="calendar"
            />
        </>
    )
}

export default DateFilter
